export const localDictionnary = {
    fr: {
        word: "mot",
        kanji: "kanji",
        indicative: "INDICATIF",
        progressive: "PROGRESSIF",
        desiderative: "DESIDERATIF",
        nonPast: "présent",
        past: "passé",
        nonPastProgressive: "progressif",
        pastProgressive: "progressif passé",
        nonPastDesiderative: "désidératif",
        pastDesiderative: "désidératif passé",
        volitional: "volitif",
        adverb: "adverbe",
        affirmative: "+",
        negative: "-",
        neutral: "neutre",
        polite: "formel",
        stem: "stem",
        teForm: "forme en -te",
        detectedSentence: "Phrase détectée",
        wordsConflict: "Plusieurs mots peuvent correspondre",
        noJLPT: "Hors JLPT",
        honorific: "honorifique",
        seeMore: "Voir tout",
        seeLess: "Voir moins",
        kanjiTakenFrom: "KANJI QUI LE COMPOSENT",
        kanjiUsedIn: "KANJI QUI L'UTILISENT",
        kanjiOrigin: "SINOGRAMME D'ORIGINE (CHINOIS MOYEN)",
        sameMeaning: "même sens qu'en japonais",
        sentences: "PHRASES",
        relatedWords: "MOTS ASSOCIÉS",
        synonyms: "SYNONYME",
        baseWord: "NOM UTILISÉ",
        suruForm: "FORME VERBALE AVEC SURU",
        stemForm: "FORME EN STEM",
        verbForm: "FORME VERBALE",
        wordUsedIn: "MOTS QUI L'UTILISENT",
        wordTakenFrom: "MOTS UTILISÉS",
        searchPlaceholder: "Rechercher en japonais, romaji, français...",
        inflexions: "CONJUGAISON",
        noKanjiInKanji: "Ce kanji n'est composé d'aucun autre kanji",
        kanjiInNoKanji: "Ce kanji n'est utilisé dans aucun autre kanji",
        noKunyomi: "Ce kanji ne comporte aucun kunyomi",
        noOnyomi: "Ce kanji ne comporte aucun onyomi",
        irregularReading: "lecture irrégulière",
        irregularReadings: "LECTURES IRRÉGULIÈRES",
        chineseLegacy: "Lecture kanji héritée du chinois.",
        noJukujikun: "Ce kanji ne comporte aucun jukujikun",
        noKanji: "Ce mot n'est composé d'aucun kanji",
        noWord: "Aucun mot associé n'a été trouvé",
        noSentence: "Aucune phrase trouvée avec ce mot",
        noSelection: "Aucun filtre sélectionné",
        retrieveLastSearch: "Reprendre à la dernière recherche",
        selectCategory: "Sélectionner une catégorie pour en afficher le contenu",
        selectCategory2: "Filtrer par classe grammaticale, niveau JLPT ou collection",
        emptyKanjiSearch: "Aucun kanji ne correspond à ces filtres",
        emptyWordSearch: "Aucun mot ne correspond à ces filtres",
        searchGlobalTip: "Lancez une recherche ou appliquez des catégories pour commencer à explorer",
        appDescription: `Tetsudai a pour vocation d'assister l'étudiant en japonais durant son apprentissage de la langue,
            en lui fournissant un dictionnaire focalisé sur l'interconnexion du vocabulaire et des kanji.`,
    },
    en: {
        word: "word",
        kanji: "kanji",
        indicative: "INDICATIVE",
        progressive: "PROGRESSIVE",
        desiderative: "DESIDERATIVE",
        nonPast: "present",
        past: "past",
        nonPastProgressive: "progressive",
        pastProgressive: "past progressifve",
        nonPastDesiderative: "desidérative",
        pastDesiderative: "past desidérative",
        volitional: "volitional",
        adverb: "adverb",
        affirmative: "+",
        negative: "-",
        neutral: "neutral",
        polite: "formal",
        stem: "stem",
        teForm: "te-form",
        detectedSentence: "Detected sentence",
        wordsConflict: "Several words may correspond",
        noJLPT: "Out of JLPT",
        honorific: "honorific",
        seeMore: "See all",
        seeLess: "See less",
        kanjiTakenFrom: "KANJI THAT COMPOSE IT",
        kanjiUsedIn: "KANJI THAT USE IT",
        kanjiOrigin: "ORIGINAL SINOGRAM (MIDDLE CHINESE)",
        sameMeaning: "same meaning as in Japanese",
        sentences: "SENTENCES",
        relatedWords: "RELATED WORDS",
        synonyms: "SYNONYM",
        baseWord: "USED NOUN",
        suruForm: "SURU VERB FORM",
        stemForm: "STEM FORM",
        verbForm: "VERB FORM",
        wordUsedIn: "WORDS THAT USE IT",
        wordTakenFrom: "WORDS USED",
        searchPlaceholder: "Search in Japanese, romaji, English...",
        inflexions: "INFLEXIONS",
        noKanjiInKanji: "This kanji is not composed of any other kanji",
        kanjiInNoKanji: "This kanji is not used in any other kanji",
        noKunyomi: "This kanji has no kunyomi readings",
        noOnyomi: "This kanji has no onyomi readings",
        irregularReading: "irregular reading",
        irregularReadings: "IRREGULAR READINGS",
        chineseLegacy: "Kanji reading inherited from Chinese.",
        noJukujikun: "This kanji has no jukujikun",
        noKanji: "This word doesn't contain any kanji",
        noWord: "No related word has been found",
        noSentence: "No sentence with this word has been found",
        noSelection: "No filter has been selected",
        retrieveLastSearch: "Resume the last search",
        selectCategory: "Select a category to display its content",
        selectCategory2: "Filter by grammar class, JLPT level, or collection",
        emptyKanjiSearch: "No kanji match these filters",
        emptyWordSearch: "No words match these filters",
        searchGlobalTip: "Start a search or apply categories to begin exploring",
        appDescription: `Tetsudai is designed to assist students in learning the Japanese language
            by providing a dictionary focused on the interconnection of vocabulary and kanji.`,
    }
}